import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const AboutPage = () => (
  <Layout>
    <SEO title="about" />
    <h1>About</h1>
    <p>This site is under contstruction.</p>
  </Layout>
)

export default AboutPage
